import {
  Box,
  Typography,
  Stack,
  Card,
  Avatar,
  Grid,
  Button,
  Chip,
} from "@mui/material";
import Layout from "../../../components/Layout";
import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { hideLoader, showLoader } from "../../../utils/loader";
import { customBaseUrl, httpGet } from "../../../store/http";

import Swal from "sweetalert2";
import UpdateAdmninPass from "./shared/components/updatePassword";

const EditSuperProfile = () => {
  const { id } = useParams();
  const [showUpdatePass, setShowUpdatePass] = useState(false);
  const [userModel, setUserModel] = useState({
    firstName: "",
    surname: "",
    dateOfBirth: "",
    email: "",
    gender: "",
    phoneNumber: "",
    smsAlertConfig: "",
    id: "",
    lastLoginAt: "",
    userType: "",
    status: "",
    createdAt: "",
    roles: [],
  });

  useEffect(() => {
    const getUser = async () => {
      showLoader();
      const response = await httpGet(
        `${customBaseUrl.authUrl}/admin/users/${id}`,
      );
      hideLoader();

      if (response.success !== true) {
        Swal.fire({
          title: "Error",
          text: "Something went wrong",
          icon: "error",
          confirmButtonText: "Ok",
        });
        return;
      }

      const user = response.data;

      setUserModel({
        firstName: user.firstName,
        surname: user.lastName,
        dateOfBirth: user.dateOfBirth,
        email: user.email,
        gender: user.gender,
        phoneNumber: user.phoneNumber,
        smsAlertConfig: user.smsAlertConfig,
        id: user.id,
        lastLoginAt: user.lastLoginAt,
        userType: user.userType,
        status: user.status,
        createdAt: user.createdAt,
        roles: user.roles,
      });
    };

    getUser();
  }, [id]);

  /** LOGICS */
  const handleShowPasswordModal = () => {
    setShowUpdatePass(true);
  };

  return (
    <Layout>
      <div>
        <Box
          sx={{
            mb: 8,
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            alignItems: { xs: "flex-start", md: "center" },
            justifyContent: "space-between",
          }}
        >
          <Box>
            <Typography variant="h4" fontWeight="bold">
              Admin Profile
            </Typography>
            <Typography variant="body2" sx={{ mt: 1 }}>
              Manage your account settings and information
            </Typography>
          </Box>

          <Stack
            direction="row"
            spacing={2}
            sx={{
              mt: { xs: 3, md: 0 },
            }}
          >
            <Button variant="contained" onClick={handleShowPasswordModal}>
              Change Password
            </Button>
          </Stack>
        </Box>

        <Card
          sx={{
            border: "1px solid",
            borderColor: "divider",
            bgcolor: "transparent",
            boxShadow: 0,
          }}
        >
          <Box sx={{ p: 4 }}>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 3,
                mb: 4,
              }}
            >
              <Avatar
                sx={{
                  width: 96,
                  height: 96,
                  borderColor: "primary.main",
                }}
                alt={userModel?.firstName}
                src={userModel?.profilePictureUrl}
              >
                {`${userModel.firstName[0]}.${userModel.surname[0]}` || "Admin"}
              </Avatar>

              <Box>
                <Typography variant="h5" fontWeight="bold">
                  {userModel?.firstName} {userModel?.surname}
                </Typography>
                <Typography variant="body2" color="text.secondary" mt={0.5}>
                  ID: {userModel?.id}
                </Typography>
              </Box>
            </Box>
            <Box sx={{ height: 1, bgcolor: "divider", mb: 4 }} />

            <Grid container spacing={4}>
              <Grid
                item
                xs={12}
                md={6}
                sx={{ display: "flex", flexDirection: "column", gap: 3 }}
              >
                <Box>
                  <Typography
                    variant="body2"
                    fontWeight="medium"
                    color="text.secondary"
                  >
                    Full Name
                  </Typography>
                  <Typography variant="body1" mt={1}>
                    {userModel?.firstName} {userModel?.surname}
                  </Typography>
                </Box>

                <Box>
                  <Typography
                    variant="body2"
                    fontWeight="medium"
                    color="text.secondary"
                  >
                    Email Address
                  </Typography>
                  <Typography variant="body1" mt={1}>
                    {userModel?.email}
                  </Typography>
                </Box>

                <Box>
                  <Typography
                    variant="body2"
                    fontWeight="medium"
                    color="text.secondary"
                  >
                    Phone Number
                  </Typography>
                  <Typography variant="body1" mt={1}>
                    {userModel?.phoneNumber}
                  </Typography>
                </Box>

                <Box>
                  <Typography
                    variant="body2"
                    fontWeight="medium"
                    color="text.secondary"
                  >
                    Role
                  </Typography>
                  <Stack direction={"row"} spacing={2} mt={1}>
                    <Chip
                      label={userModel.userType}
                      sx={{
                        bgcolor: "primary.light",
                        color: "#fff",
                        fontWeight: "medium",
                      }}
                    />
                    {userModel.roles.map((role) => (
                      <Chip
                        label={role.replace(/_/g, " ")}
                        key={role}
                        sx={{
                          bgcolor: "primary.light",
                          color: "#fff",
                          fontWeight: "medium",
                        }}
                      />
                    ))}
                  </Stack>
                </Box>
              </Grid>
              <Grid
                item
                xs={12}
                md={6}
                sx={{ display: "flex", flexDirection: "column", gap: 3 }}
              >
                <Box>
                  <Typography
                    variant="body2"
                    fontWeight="medium"
                    color="text.secondary"
                  >
                    Account Status
                  </Typography>
                  <Box mt={1}>
                    <Chip
                      label={userModel?.status}
                      icon={
                        <Box
                          sx={{
                            width: 8,
                            height: 8,
                            borderRadius: "50%",
                            bgcolor: "text.primary",
                            mr: 1,
                          }}
                        />
                      }
                      sx={{
                        bgcolor: "primary.light",
                        color: "primary.contrastText",
                        fontWeight: "medium",
                      }}
                    />
                  </Box>
                </Box>

                <Box>
                  <Typography
                    variant="body2"
                    fontWeight="medium"
                    color="text.secondary"
                  >
                    Last Login
                  </Typography>
                  <Typography variant="body1" mt={1}>
                    {userModel?.lastLoginAt}
                  </Typography>
                </Box>

                <Box>
                  <Typography
                    variant="body2"
                    fontWeight="medium"
                    color="text.secondary"
                  >
                    Date Created
                  </Typography>
                  <Typography variant="body1" mt={1}>
                    {userModel?.createdAt}
                  </Typography>
                </Box>
              </Grid>
            </Grid>
          </Box>
        </Card>
      </div>
      {showUpdatePass && (
        <UpdateAdmninPass
          showModal={showUpdatePass}
          hideModal={setShowUpdatePass}
          email={userModel?.email}
        />
      )}
    </Layout>
  );
};

export default EditSuperProfile;
